import { Box } from '@material-ui/core';
import { CSSProperties } from 'react';
import { useStyles } from '../styles';

interface ThreeDotIndicatorProps {
  className?: string;
  style?: CSSProperties;
}

export function ThreeDotIndicator({
  className,
  style,
}: ThreeDotIndicatorProps) {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={className}
      style={style}
    >
      <div
        className={`w-2 h-2 rounded-full mx-1 animate-pulse ${classes.workLogLoaderDot}`}
      />
      <div
        className={`w-2 h-2 rounded-full mx-1 animate-pulse ${classes.workLogLoaderDotDelayed200}`}
      />
      <div
        className={`w-2 h-2 rounded-full mx-1 animate-pulse ${classes.workLogLoaderDotDelayed400}`}
      />
    </Box>
  );
}
